module.exports = __webpack_public_path__ + "static/BFB_LITTLE_FAIRY_OOH-4113ff2eff03084f28387a453882a48c.jpg";